<template>
    <div id="message-panel">
        <div class="notice"></div>
        <div class="message-list"></div>
        <div class="message-sender" id="bjy_message_sender"></div>
        <div class="bjy-message-sender message-sender-custom" data-skin="light">
            <div class="bjy-no-forbidden">
                <div class="bjy-message-input">
                    <div class="bjy-input-component">
                        <textarea
                            v-model="customVal"
                            @keyup.enter="onSentMsg"
                            class="bjy-input"
                            placeholder="请输入...."
                        ></textarea>
                    </div>
                </div>
                <div class="bjy-action-bar">
                    <div class="bjy-float">
                        <div class="bjy-button-group"></div>
                        <button @click="onSentMsg" class="bjy-button bjy-send-message" :disabled="!customVal">
                            发送
                        </button>
                    </div>
                    <span class="bjy-length-hint">
                        <span class="bjy-my-length">{{ customVal.length }}</span>/<span class="bjy-max-length">400</span>
                    </span>
                    <div class="bjy-quick-reply-layer bjy-tooltip bjy-default bjy-top">
                        <ul class="bjy-quick-reply-list-talk"></ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import userRoleMap from './common/roleMap'
const auth = BJY.auth
const store = BJY.store
const eventEmitter = BJY.eventEmitter
let messageList = null
let notice = null
let messageSender = null
export default {
    props: ['liveInfo'],
    data() {
        return {
            customVal: '',

            hasForbidden: false,
        }
    },
    watch: {
        'liveInfo.userForbiddenTalk': function () {
            this.updateMsgContainer()
        },
        hasForbidden: function () {
            this.updateMsgContainer()
        },
    },
    methods: {
        onSentMsg() {
            if (this.customVal) {
                eventEmitter.trigger(eventEmitter.MESSAGE_SEND, {
                    to: '100000000000000404',
                    content: this.customVal,
                })
                this.customVal = ''
            }
        },
        updateMsgContainer() {
            $('#message-panel .message-sender').css('display', 'none')
            $('#message-panel .message-sender-custom').css('display', 'none')

            console.log('禁言1', this.messageForbid)
            console.log('禁言2', this.messageAllForbid)
            console.log('禁言3', this.liveInfo.userForbiddenTalk)

            let _state = true
            if (this.messageForbid && this.messageForbid.forbidSelf) {
                if (this.messageForbid.duration !== -1) {
                    _state = false
                }
            }

            if (this.liveInfo && this.liveInfo.userForbiddenTalk) {
                _state = false
            }

            if (this.messageAllForbid && this.messageAllForbid.forbidAll) {
                _state = true
            }

            if (this.hasForbidden) {
                _state = false
            }

            if (_state) {
                $('#message-panel .message-sender').css('display', 'block')
            } else {
                $('#message-panel .message-sender-custom').css('display', 'block')
            }
        },
    },
    created() {
        // 收到新消息时tab栏对应tab给出提示
        eventEmitter.on(eventEmitter.MESSAGE_RECEIVE, function (e, date) {
            var element = $('#btn-message-list')
            if (!element.hasClass('active')) {
                element.addClass('has-new')
            }
        })

        eventEmitter.on(eventEmitter.MESSAGE_SEND_FORBID, (e, date) => {
            this.messageForbid = date
            this.updateMsgContainer()
        })
        eventEmitter.on(eventEmitter.MESSAGE_SEND_FORBID_ALL_CHANGE, (e, date) => {
            this.messageAllForbid = date
            this.updateMsgContainer()
        })
    },
    mounted() {
        // 公告
        notice = BJY.Notice.create({
            element: $('#message-panel .notice'), // 父容器
            replace: false,
            defaultContent: '这里空空如也...', // 默认无公告时显示文本
            maxLength: 400, // 公告文本最大长度
            contentPlaceholder: '请输入公告正文内容', // 公告文本编辑框提示
            linkPlaceholder: '请输入公告跳转链接（可选）', // 公告链接编辑框提示
            linkErrorHint: 'URL 格式错误', // url 错误提示
            canEdit: auth.isTeacher() || auth.isAssistant(),
        })
        // 创建消息列表组件
        messageList = BJY.MessageList.create({
            element: $('#message-panel .message-list'),
            renderEmoji: function (name, url) {
                if (BJY.isAlicloudImage(url)) {
                    return (
                        '<img ondragstart="return false" src="' +
                        (url + '@100w_1e_1l.png') +
                        '" srcset="' +
                        (url + '@200w_1e_1l.png') +
                        ' 2x">'
                    )
                }
                return '<img ondragstart="return false" src="' + url + '">'
            },
            renderImage: function (url) {
                if (BJY.isAlicloudImage(url)) {
                    return (
                        '<img ondragstart="return false" src="' +
                        (url + '@100w_1e_1l.png') +
                        '" srcset="' +
                        (url + '@200w_1e_1l.png') +
                        ' 2x">'
                    )
                }
                return '<img ondragstart="return false" src="' + url + '">'
            },
            renderUser: function (user, width, height) {
                return {
                    id: user.id,
                    name: user.name,
                    number: user.number,
                    // 头像需压缩
                    avatar: BJY.compressImage({
                        url: user.avatar,
                        width: width,
                        height: height,
                    }),
                    avatar2x: BJY.compressImage({
                        url: user.avatar,
                        width: width * 2,
                        height: height * 2,
                    }),
                    // 根据用户类型，配置角色的英文和本地语言
                    role: userRoleMap[user.type].en,
                    localRole: userRoleMap[user.type].cn,
                    type: user.type,
                }
            },
            loadDistance: 0,
        })

        // 创建消息发送组件
        messageSender = BJY.MessageSender.create({
            element: $('#message-panel .message-sender'),
            canSendEmoji: false,
            canSendImage: false,
            multiline: true,
            messageMaxLength: 400,
            placeholder: '请输入...',
            emotionList: {
                emotionPerRow: 6,
                rowPerPage: 4,
            },
        })
        this.updateMsgContainer()
        // 监控
        const _targetNode = document.getElementById('bjy_message_sender')
        const _observer = new MutationObserver(() => {
            const hasForbidden = _targetNode.querySelector('.bjy-has-forbidden') !== null
            this.hasForbidden = hasForbidden
        })
        const _config = { attributes: true, childList: true, subtree: true }
        _observer.observe(_targetNode, _config)
    },
    beforeDestroy() {
        messageSender && messageSender.destroy()
        messageList && messageList.destroy()
        notice && notice.destroy()
    },
}
</script>

<style lang="scss">
//@import url(); 引入公共css类
#message-panel {
    width: 100%;
    height: 100%;

    .notice {
        position: absolute;
        top: 0;
        z-index: 1;
        background: #fff;
        width: 100%;
        // border-top: 1px solid #ddd;
    }

    .bjy-message-list {
        bottom: 110px;
        height: unset;
        top: 32px;
    }

    .bjy-message-reference {
        box-sizing: border-box;
    }
    .bjy-message-sender {
        position: absolute;
        bottom: 10px;
        width: 100%;
    }
    .bjy-message-item .bjy-whisper-title {
        display: none;
    }

    .message-sender-custom {
        position: absolute;
        bottom: 10px;
        width: 100%;
        display: none;
    }
}
</style>
